import { ElementViewTemplate, html, repeat } from '@microsoft/fast-element';
import { NatGenLoader } from './loader';

export function loaderTemplate<T extends NatGenLoader>(): ElementViewTemplate<T> {
    return html<T>`
        ${repeat((x, c) => x.parts(), html<number>`<div style="--part: ${(x, c) => c.index}; --total: ${x => x};"></div>`, { positioning: true })}
    `;
}
